import { API } from "aws-amplify";

export const callHome = (uavId: string) => {
  return API.post("sky", `/admin/uav/${uavId}/call-home`, {
    body: {},
  });
};

export const callHomeInCell = (cellId: number) => {
  return API.post("sky", `/admin/fleet/call-home-in-cell/${cellId}`, {
    body: {},
  });
};
